import { theme } from '@/styles';
import React from 'react';
import styled from 'styled-components';

const ThirdParties = ({ kind }: { kind: 'quick' | 'untact' }) => {
  const CONTENT = [
    {
      id: 1,
      title: '제공받는 자 : 한샘 대리점, 한샘 제휴점',
      children: [],
    },
    {
      id: 2,
      title: '제공 목적',
      children: [
        '상담 서비스 이행, 제품 상담 및 견적 서비스 제공',
        '제품 설치- 고객 상담 서비스 제공',
      ],
    },
    {
      id: 3,
      title: '제공 항목',
      children: ['이름, 휴대폰 번호, 주소', '상담에 필요한 현장 공사 정보'],
    },
    {
      id: 4,
      title: '보유 및 이용 기간',
      children:
        kind === 'quick'
          ? ['회원: 회원 탈퇴 시 까지', '비회원: 서비스 종료 후 1년']
          : ['회원 탈퇴 시 까지'],
    },
  ];
  return (
    <Container>
      <TextDefault>
        {`상담 예약 서비스 제공을 위해 아래와 같이 개인정보를 제3자에게 제공하고자 합니다. 내용을 자세히 읽으신 후 동의해 주시기 바랍니다. 이용자가 동의한 내용 외의 다른 목적으로 사용하지 않으며, 이용자는 동의를 거부할 권리가 있습니다. 단, 동의 거부 시 상담신청 서비스를 받으실 수 없습니다. 그 밖의 사항은 (주) 한샘 개인정보처리 방침에 따릅니다.`}
      </TextDefault>

      {CONTENT.map((item) =>
        item.id === 3 ? (
          <TextDefault key={item.id}>
            {`${item.id}.  ${item.title}`}
            <List>
              {item.children.map((val, idx) => (
                <ListITtem key={idx}>{val}</ListITtem>
              ))}
            </List>
          </TextDefault>
        ) : (
          <TextBold key={item.id}>
            {`${item.id}.  ${item.title}`}
            <List>
              {item.children.map((val, idx) => (
                <ListITtem key={idx}>{val}</ListITtem>
              ))}
            </List>
          </TextBold>
        ),
      )}
    </Container>
  );
};

export default ThirdParties;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 0px 40px 40px 40px;
`;

const TextDefault = styled.div`
  color: ${theme.colors.neutral_colors.gray[700]};
  ${theme.typography.body2};
`;

const TextBold = styled.div`
  color: ${theme.colors.accent_colors.primary.default};
  ${theme.typography.subtitle5};
`;

const List = styled.ul``;

const ListITtem = styled.li`
  list-style: disc !important;
  margin-left: 30px;
`;
